import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";

const MAP = {
  Desc: "NULL",
  Done: "S",
  Block: "N",
  NA: "NA",
  Atenção: "A",
  I: "I",
  Regular: "R",
  Normal: "NO",
  "Agendar Troca": "AT",
  Trocar: "TR",
} as const;

type Key = keyof typeof MAP;

export default function AnswerDialog({
  open,
  onClose,
  onSubmit,
  proximaOrdem,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { descricao: Key; valor: string; ordem: number }) => void;
  proximaOrdem: number;
}) {
  const [tipo, setTipo] = useState<Key>("Done");
  const [ordem, setOrdem] = useState<number>(proximaOrdem);

  const handleOk = () => {
    onSubmit({ descricao: tipo, valor: MAP[tipo], ordem });
    setTipo("Done");
    setOrdem(proximaOrdem);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Nova Resposta</DialogTitle>
      <DialogContent>
        <Box mt={1} display="grid" gap={2}>
          <ToggleButtonGroup
            exclusive
            value={tipo}
            onChange={(_, v) => v && setTipo(v)}
            color="primary"
          >
            {Object.keys(MAP).map((k) => (
              <ToggleButton key={k} value={k}>
                {k}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          <TextField
            label="Ordem"
            type="number"
            value={ordem}
            onChange={(e) => setOrdem(Number(e.target.value))}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleOk}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
